import { useGeoMarkupStore } from '@/store';

export function useFormConflictDialog() {
  const showDialog = useGeoMarkupStore((s) => s.formConflict.showDialog);
  const confirmSwitch = useGeoMarkupStore((s) => s.formConflict.confirmSwitch);
  const cancelSwitch = useGeoMarkupStore((s) => s.formConflict.cancelSwitch);
  return { showDialog, confirmSwitch, cancelSwitch };
}
